module.exports = __webpack_public_path__ + "static/media/activities.1f87f46d.svg";